import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  answerIds: number[];
  courseId: number;
  onDataChange: () => Promise<void>;
}

const AnswerDeleteAll = ({ answerIds, courseId, onDataChange }: Props) => {
  const { messages } = useReduxState();

  const deleteAll = async () => {
    const response = await api.delete(
      `/admin/courses/${courseId}/answers?answerIds=${answerIds}`
    );
    if (!response.data || !response.data.success) return false;

    await onDataChange();

    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonDeleteAllAnswers}
      category="danger"
      confirmText={messages.commonDeleteAllAnswersConfirm}
      confirmTitle={messages.commonDeleteAllAnswers}
      disabled={!answerIds.length}
      onConfirm={deleteAll}
      successMessage={messages.commonDeleteAllAnswersSuccess}
    />
  );
};

export default AnswerDeleteAll;
